module.exports = __webpack_public_path__ + "static/residentialfiber-cf1f58987c0fbc1259be68670efedd02.png";